import { NO_VALUE_SELECTED_ERROR } from '../../../utils/formValidation/commonErrorConstants';
import { validatePostcode } from '../../../utils/formValidation/validationFunctions';
import { regExps } from '../../../utils/formValidation/validationPatterns';

const ERROR_NO_VALUE = 'Please enter a value';
const ERROR_POSTCODE_FORMAT = 'Must be in the correct UK postcode format';
export const EXTERNAL_REFERENCE_NUMBER_MAX_LENGTH = 50;

export const initialErrorState = {
    serviceId: { error: false, message: '' },
    maximumPostcodeDistanceId: { error: false, message: '' },
    postcode: { error: false, message: '' }
};

export const validate = (newEntry, errors) => {
    let isValid = true;
    let newErrors = errors;

    if (!newEntry.serviceId && !newEntry.externalReferenceNumber) {
        newErrors = {
            ...newErrors,
            serviceId: { error: true, message: NO_VALUE_SELECTED_ERROR }
        };
        isValid = false;
    }

    if (newEntry.postcode && !newEntry.maximumPostcodeDistanceId) {
        newErrors = {
            ...newErrors,
            maximumPostcodeDistanceId: { error: true, message: NO_VALUE_SELECTED_ERROR }
        };
        isValid = false;
    }

    if (newEntry.postcode && !newEntry.postcode.match(regExps.POSTCODE_R)) {
        newErrors = {
            ...newErrors,
            postcode: { error: true, message: ERROR_POSTCODE_FORMAT }
        };
        isValid = false;
    }

    if (newEntry.maximumPostcodeDistanceId && !newEntry.postcode) {
        newErrors = {
            ...newErrors,
            postcode: { error: true, message: ERROR_NO_VALUE }
        };
        isValid = false;
    } else if (newEntry.maximumPostcodeDistanceId) {
        newErrors = validatePostcode(newEntry.postcode, newErrors);
    }

    const firstError = Object.keys(newErrors).find((el) => newErrors[el].error);
    firstError && document.getElementById(firstError).focus();

    return { isValid, newErrors };
};
